import { MapPin, User, ShoppingCart } from "lucide-react";
import { useState, useEffect } from "react";
import { useAuth } from "../Context/AuthContext";
import LoginModal from "../Components/LoginPage";
import DeliveryLocationModal from "../Components/DeliveryLocationModal";
import AccountDropdown from "../Components/AccountDropdown";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../Context/CartContext";
import Logo from "../Assets/Logo Png.png";

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  //  const [cartCount, setCartCount] = useState(0);



  const [openAccount, setOpenAccount] = useState(false);
  const [openLogin, setOpenLogin] = useState(false);
  const [openLocation, setOpenLocation] = useState(false);
  const [pincode, setPincode] = useState("395010");


  const { cartCount } = useCart();
  console.log(cartCount)



  const data = useCart();
  console.log(data);



  useEffect(() => {
    const openLoginModal = () => setOpenLogin(true);
    window.addEventListener("open-login-modal", openLoginModal);
    return () =>
      window.removeEventListener("open-login-modal", openLoginModal);
  }, []);

  const displayName = user?.email
    ? user.email.slice(0, 5) + ".."
    : user?.phone
      ? user.phone.slice(0, 4) + "****"
      : "";

  return (
    <>
      <nav className="w-full bg-white border-b sticky top-0 z-50 shadow-sm">
        <div className="max-w-[1440px] mx-auto h-[72px] flex items-center justify-between px-6">
          {/* LEFT */}
          <Link to="/">


            <div className="flex items-center gap-3">
              <img
                src={Logo}
                className=" h-9"
              />
              {/* <div>
                <p className="font-semibold text-teal-700">Cosmic</p>
                <p className="font-semibold text-teal-700">Careness</p>
              </div> */}
            </div>
          </Link>

          {/* CENTER */}
          <div
            onClick={() => setOpenLocation(true)}
            className="hidden md:flex items-center gap-3 bg-gray-50 border rounded-xl px-4 py-2 cursor-pointer"
          >
            <MapPin className="w-5 h-5 text-pink-500" />
            <div>
              <p className="text-xs text-gray-500">Express delivery to</p>
              <p className="text-sm font-semibold">{pincode}</p>
            </div>
          </div>

          {/* RIGHT */}
          <div className="flex items-center gap-6">
            {!user ? (
              <div
                onClick={() => setOpenLogin(true)}
                className="flex items-center gap-2 cursor-pointer"
              >
                <User className="w-5 h-5" />
                <span>Login</span>
              </div>
            ) : (
              <div
                onClick={() => setOpenAccount(true)}
                className="flex items-center gap-2 bg-gray-100 px-3 py-1.5 rounded-full cursor-pointer"
              >
                <User className="w-4 h-4" />
                <span className="text-sm font-medium">{displayName}</span>
              </div>
            )}

            <div
              className="flex items-center gap-2 cursor-pointer"
              onClick={() => navigate("/cart")}
            >
              <ShoppingCart className="w-5 h-5" />
              <span className="font-semibold">Cart ({cartCount})</span>
            </div>

          </div>
        </div>
      </nav>

      {openLogin && <LoginModal onClose={() => setOpenLogin(false)} />}

      {openLocation && (
        <DeliveryLocationModal
          onClose={() => setOpenLocation(false)}
          onSelectLocation={(pin) => setPincode(pin)}
        />
      )}

      {openAccount && (
        <AccountDropdown
          user={user}
          onClose={() => setOpenAccount(false)}
          onLogout={() => {
            logout();
            setOpenAccount(false);
          }}
        />
      )}
    </>
  );
};

export default Navbar;
